<template>
  <v-autocomplete outlined dense hide-details flat clearable v-bind="$attrs" v-on="$listeners">
    <!-- Slots -->
    <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
    <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "core-autocomplete-table-header",
  props: {},
  components: {},
}
</script>
